
import {computed, createVNode, onMounted, reactive, ref, toRaw, toRefs, watch} from "vue";
import {Options, setup, Vue} from "vue-class-component";
import managementService from "@/api/managementService";
import MessageService from "@/utils/message";
import InfoWrapper from "@/components/InfoWrapper.vue";
import ZhTab from "@/components/TabSet/ZhTab.vue";
import ZhTabSet from "@/components/TabSet/ZhTabSet.vue";
import {Modal} from "ant-design-vue";
import todoService from "@/api/todoService";
import EditOrAddModal from "@/components/EditOrAddModal.vue";
// import workOrderService from "@/api/workOrderService";
// import enterpriseService from "@/api/enterpriseService";
import {
  DownOutlined, ExclamationCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  RedoOutlined,
  SearchOutlined,
  UpOutlined,
} from "@ant-design/icons-vue";
import {useStore} from "vuex";
import FilterSearch from "@/components/table/FilterSearch.vue";
import FormUtils from "@/utils/formUtils";
import IndicatorBox from "@/components/IndicatorBox/IndicatorBox.vue";
import BottomToolBarV2 from "@/components/BottomToolBarV2.vue";
import moment from "moment";
import customerService from "@/api/customerService";
import smsMessageService from "@/api/smsMessageService";
import dateUtils from "@/utils/dateUtils";
let context: any;
let parkInfo: any;
let userData: any;
@Options({
  name: 'information-template',
  components: {
    BottomToolBarV2,
    IndicatorBox,
    FilterSearch,
    InfoWrapper,
    ZhTabSet,
    ZhTab,
    SearchOutlined,
    RedoOutlined,
    DownOutlined,
    UpOutlined,
    PlusOutlined,
    EditOrAddModal,
  },
})
export default class InformationTemplate extends Vue {
  created() {
    context = this;
  }

  tableInfo = setup(() => {
    const store = useStore();
    const {currentParkInfo} = toRefs(store.state);
    parkInfo = currentParkInfo.value;
    
    let isHas = ref(true);
    //搜索框定义
    const rows = reactive({
      name: {
        name: "模板名称",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
      code:{
        name: "编码",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
      startTime: {
        name: "开始时间",
        type: "date",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },
      endTime: {
        name: "结束时间",
        type: "date",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 160,
      },

    });
    const rules = reactive({
      name: [
        {required: false, message: "请输入服务机构名称", trigger: "blur"},
      ],
      startTime: [
        {required: false, message: "请选择开始时间", trigger: "change"},
      ],
      endTime: [
        {required: false, message: "请选择结束始时间", trigger: "change"},
      ],

    });

    const reqParams: any = {
      name: '',
      startTime: null,
      endTime: null
    }

    const cols = reactive([
      {dataIndex: "name", key: "name", title: "名称", fixed: 'left'},
      {dataIndex: "code", key: "code", title: "编码"},
      {dataIndex: "remark", key: "remark", title: "备注"},
      {dataIndex: "dutyObject", key: "dutyObject", title: "责任对象"},
      {dataIndex: "superviseObject", key: "superviseObject", title: "监管对象"},
      {dataIndex: "superviseTriggerMinute", key: "superviseTriggerMinute", title: "触发监管时长"},
      {dataIndex: "isSendSms", key: "isSendSms", title: "是否发送短信", slots: {customRender: "isSms"}},
      {dataIndex: "contentTemplate", key: "contentTemplate", title: "待办内容模板"},
      {dataIndex: "smsTemplateCode", key: "smsTemplateCode", title: "短信模板标识"},
      {dataIndex: "smsTemplateConfig", key: "smsTemplateConfig", title: "短信模板内容配置"},
      {
        dataIndex: "crtUser",
        key: "crtUser",
        title: "创建用户",
        slots: {customRender: "status"},
      },
      {
        dataIndex: "operation",
        key: "operation",
        title: "操作管理",
        fixed: "right",
        slots: {customRender: "ope"},
      },
    ]);

    const metadata = reactive<Array<any>>([]);

    const pageInfo = reactive<any>({
      total: 0,
      size: 40,
      page: 1,
    });

    const pageParams = computed(() => {
      return {
        page: pageInfo.page,
        size: pageInfo.size,
      };
    });

    const paginationConfig = computed(() => {
      return {
        total: pageInfo.total,
        "show-size-changer": true,
        "show-total": (total: number) => `模板总计 ${total} 个`,
        current: pageInfo.page,
        pageSize: pageInfo.size,
      };
    });

    const data = computed(() => metadata.map((info: any) => convertInfo(info)));
    //多选
    const state = reactive<any>({
      selectedRowKeys: [],
      totalData: [],
      selectedRows: []
    });
    const bottomToolBarButtonList = computed(() => {
      return [
        {
          title: "批量导出",
          callback: excelOut

        },
        {
          title: "批量删除",
          callback: deleteMultipleData

        },
      ];
    });
    //convert data
    let organization = reactive({
      arr: [],
    });

    let toDoUserGroupList = reactive({
      arr: [],
    });

    let enterList = reactive({
      arr: [],
    });

    let objectTypeList = reactive({
      arr: [
        {id: 0, name: '自定义人员组'},
        {id: 1, name: '组织'},
        {id: 2, name: '企业'},
        {id: 3, name: '触发对象传入组织'},
        {id: 4, name: '触发对象传入人员'}
      ],
    });

    const dutyObjectList = reactive({
      arr: []
    })

    const superviseObjectList = reactive({
      arr: []
    })

    let detailData = ref<any>({});

    let visible = ref(false);
    let userList = reactive({
      arr: [],
    });


    const onTableChange = (pagination: any) => {
      pageInfo.page = pagination.current;
      pageInfo.size = pagination.pageSize;
    };

    watch(pageParams, () => {
      getData();
    });


    const research = () => {
      resetParams();
      search();
    };
    const resetParams = () => {
      for (let key in reqParams) {
        reqParams[key] = null;
      }
    };
    const search = () => {
      resetState();
      pageInfo.page = 1;
      getData();
    };
    const updateReqParams = (params: any) => {
      //console.log('params from children', params)
      for (let key in params) {
        reqParams[key] = params[key];
      }
    };

    const getData = () => {
      let params = getRequestParams();
      params.parkId = parkInfo.id;
      todoService.getToDoConfigPageListByParams(params).then((result) => {
        let info = result.data;
        pageInfo.total = info.total;
        let list: any = [];
        if (info.rows.length) {
          info.rows.forEach((element: any) => {
            let data = element;
            if (element.toDoTemplateConfig) {
              let temp = element.toDoTemplateConfig;
              if (temp.dutyObjectType === 0) {
                data.dutyObject = getGroupName(temp.dutyObjectId);
              }
              if (temp.dutyObjectType === 1) {
                data.dutyObject = getOrgName(temp.dutyObjectId);
              }

              if (temp.dutyObjectType === 2) {
                data.dutyObject = getEnterName(temp.dutyObjectId);
              }

              // data.dutyObjectType = temp.dutyObjectType;
              // data.dutyObjectId = temp.dutyObjectId;
              if (temp.superviseObjectType === 0) {
                data.superviseObject = getGroupName(temp.superviseObjectId);
              }
              if (temp.superviseObjectType === 1) {
                data.superviseObject = getOrgName(temp.superviseObjectId);
              }

              if (temp.superviseObjectType === 2) {
                data.superviseObject = getEnterName(temp.superviseObjectId);
              }

              if (temp.isSendSms) {
                data.isSendSms = parseInt(temp.isSendSms);
              }

              if (temp.isSendWxOaMsg) {
                data.isSendWxOaMsg = parseInt(temp.isSendWxOaMsg);
              }
              // data.superviseObjectType = temp.superviseObjectType;
              // data.superviseObjectId = temp.superviseObjectId;
              data.superviseTriggerMinute = temp.superviseTriggerMinute;

              data.contentTemplate = temp.contentTemplate;
              data.smsTemplateCode = temp.smsTemplateCode;
              data.smsTemplateConfig = temp.smsTemplateConfig;
              data.wxAppOaId = temp.wxAppOaId;
              data.wxOaAppId = temp.wxOaAppId;
              data.wxOaOpenId = temp.wxOaOpenId;
              data.wxAppMpId = temp.wxAppMpId;
              data.wxMpAppId = temp.wxMpAppId;
              data.wxMpOpenId = temp.wxMpOpenId;

              data.wxOaMsgTemplateCode = temp.wxOaMsgTemplateCode;
              data.wxOaMsgTemplateConfig = temp.wxOaMsgTemplateConfig;
              data.isGenerateWxMpLink = temp.isGenerateWxMpLink;
              data.wxMpLinkPageTemplate = temp.wxMpLinkPageTemplate;
              data.dutyUserList = temp.dutyUserList;
              data.content = temp.content;
              data.wxMpLink = temp.wxMpLink;
              data.smsData = temp.smsData;
              data.wxMpLinkQueryTemplate = temp.wxMpLinkQueryTemplate;
              data.crtUser = temp.crtUser;
              data.crtDate = temp.crtDate;
            }
            list.push(data);
          });

        }
        //console.log(list, "list--------------------");

        metadata.splice(0, metadata.length, ...list);
      });
    };

    const convertInfo = (info: any) => {

      // //console.log('info', info)
      return FormUtils.setUndefinedColumnToRailAndColumns(info, cols);
    };

    const getRequestParams = () => {
      let params: any = {};
      Object.assign(params, reqParams, pageInfo)
      delete params.total
      return params;
    };

    const initData = () => {
      getOrgList();
      getToDoUserGroupList();
      // getEnterList();
      initUserList();
      getData();
    }

    onMounted(initData);

    const getObjectTypeName = (data: any) => {
      let type = objectTypeList.arr.find((el: any) => el.id === data);
      if (!type) {
        return;
      }
      return type.name;
    }

    // const getEnterList = () => {
    //   enterpriseService.getEnterpriseSimpleDtoListByParkId(parkInfo.id).then((result: any) => {
    //     //console.log("getOrgList-----------------------", result);
    //     if (result.status == 200) {
    //       enterList.arr = result.result;
    //     }
    //   })
    // }

    const getEnterName = (data: any) => {
      let enter: any = organization.arr.find((element: any) => element.id == data);
      if (!enter) {
        return null;
      }
      return enter.name;
    };

    const getToDoUserGroupList = () => {
      todoService.getToDoUserGroupList().then((result: any) => {
        //console.log("getOrgList-----------------------", result);
        if (result.status == 200) {
          toDoUserGroupList.arr = result.result;
        }
      })
    }

    const getGroupName = (data: any) => {
      let group: any = toDoUserGroupList.arr.find((element: any) => element.id == data);
      if (!group) {
        return null;
      }
      return group.name;
    };

    const getOrgList = () => {
      // workOrderService.queryOrgListByParkId(parkInfo.id).then((result: any) => {
      //   //console.log("getOrgList-----------------------", result);
      //   if (result.status == 200) {
      //     let list: any = [];
      //     if (result.result.length) {
      //       result.result.forEach((element: any) => {
      //         list.push({id: element.orgId, name: element.name})
      //       });
      //     }

      //     organization.arr = list;
      //   }
      // })
    }

    const getOrgName = (data: any) => {
      let org: any = organization.arr.find((element: any) => element.id == data);
      if (!org) {
        return null;
      }
      return org.name;
    };

    const dutyObjectTypeChange = () => {
      //console.log(context.addModalInfo.form.dutyObjectType, "dutyObjectTypeChange------------");
      context.addModalInfo.form.dutyObjectId = null;
      if (context.addModalInfo.form.dutyObjectType === 0) {
        dutyObjectList.arr = toDoUserGroupList.arr;
      }

      if (context.addModalInfo.form.dutyObjectType === 1) {
        dutyObjectList.arr = organization.arr;
      }

      if (context.addModalInfo.form.dutyObjectType === 2) {
        dutyObjectList.arr = enterList.arr;
      }

    };

    const superviseObjectTypeChange = () => {
      //console.log(context.addModalInfo.form.superviseObjectType, "superviseObjectTypeChange------------");
      context.addModalInfo.form.superviseObjectId = null;
      if (context.addModalInfo.form.superviseObjectType === 0) {
        superviseObjectList.arr = toDoUserGroupList.arr;
      }

      if (context.addModalInfo.form.superviseObjectType === 1) {
        superviseObjectList.arr = organization.arr;
      }

      if (context.addModalInfo.form.superviseObjectType === 2) {
        superviseObjectList.arr = enterList.arr;
      }


    };

    const seeDetail = (data: any) => {
      //console.log(data, "seeDeatil---------------");

      detailData.value = data;
      if (data.toDoTemplateConfig) {
        if (data.toDoTemplateConfig.dutyObjectType === 0) {
          if (data.toDoTemplateConfig.dutyUserIdList) {
            let userInfo = '';
            data.toDoTemplateConfig.dutyUserIdList.forEach((element: any) => {
              userInfo += getUser(element).realName + ',';
            });
            detailData.value.dutyObjectStr = userInfo;
          }
        }

        if (data.toDoTemplateConfig.dutyObjectType === 1) {
          detailData.value.dutyObjectStr = getOrgName(data.toDoTemplateConfig.dutyObjectId)
        }

        if (data.toDoTemplateConfig.dutyObjectType === 2) {
          detailData.value.dutyObjectStr = getEnterName(data.toDoTemplateConfig.dutyObjectId)
        }

        if (data.toDoTemplateConfig.superviseObjectType === 0) {
          if (data.toDoTemplateConfig.superviseUserList) {
            let userInfo = '';
            data.toDoTemplateConfig.superviseUserList.forEach((element: any) => {
              let name = getUser(element).realName;
              if (!name) {
                name = getUser(element).username;
              }
              if (userInfo != '') {
                userInfo += ','
              }
              userInfo += name;
            });
            detailData.value.superviseObjectStr = userInfo;
          }
        }

        if (data.toDoTemplateConfig.superviseObjectType === 1) {
          detailData.value.superviseObjectStr = getOrgName(data.toDoTemplateConfig.dutyObjectId)
        }

        if (data.toDoTemplateConfig.superviseObjectType === 2) {
          detailData.value.superviseObjectStr = getEnterName(data.toDoTemplateConfig.dutyObjectId)
        }

      }


      //console.log(detailData.value, "seeDeatil---------------");
      visible.value = true;
    }

    const initUserList = () => {
      managementService.getUserList().then((result: any) => {
        //console.log(result, "getUserList------------------");

        if (result.status !== 200) {
          return;
        }
        userList.arr = result.result;
      });
    };

    const getUser = (data: any) => {
      let user: any = userList.arr.find(
          (element: any) => element.id == data
      );
      if (!user) {
        return null;
      }
      return user;
    };
//多选栏

    const resetState = () => {
      for (let key in state) {
        state[key] = [];
      }
    };
    const selectAll = (data: any) => {
      if (!data.hasRequested) {
        todoService.getToDoConfigPageListByParams(data.params).then((result: any) => {
          if (result.status !== 200) {
            return;
          }
          const info = result.data;
          pageInfo.total = info.total;
          state.totalData.splice(0, state.totalData.length, ...info.rows);
          state.selectedRowKeys = state.totalData.map((el: any) => el.id);
        });
      }
    };

    const onSelectChange = (selectedRowKeys: any[], selectedRows: any[]) => {
      state.selectedRowKeys = selectedRowKeys;
      state.selectedRows = selectedRows;
    };

    //批量操作
    //TODO 批量导出，缺少接口
    const excelOut = () => {
      Modal.confirm({
        title: () => "确认导出",
        icon: () => createVNode(QuestionCircleOutlined),
        content: () => "确认要导出Excel文件？",
        okText: () => "确定",
        onOk() {
          let day = moment(new Date()).utcOffset(480).format("YYYY-MM-DD");
          let fileName = "申报信息" + day + ".xlsx";
          let params = {
            excelHeaderTitle: "申报信息",
            clientIds: state.selectedRowKeys.join()
          };
          // customerService.getPotentialClientsExcelFile(params).then((result: any) => {
          //   let blob = result;
          //   blob = new Blob([blob], {
          //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          //   });
          //   let objectUrl = URL.createObjectURL(blob);
          //   let a = document.createElement("a");
          //   document.body.appendChild(a);
          //   a.setAttribute("style", "display:none");
          //   a.download = fileName;
          //   a.href = objectUrl;
          //   a.click();
          // });
        },
        onCancel() {
          ////console.log("Cancel");
        },
        class: "test",
      });
    };
    //TODO 批量删除，缺少
    const deleteMultipleData = (data: any) => {
      Modal.confirm({
        title: () => "是否要批量删除?",
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () => `是否要批量删除，数据删除后无法恢复，请慎重考虑是否删除！`,
        okText: () => "删除",
        okType: "danger",
        cancelText: () => "取消",
        onOk() {
          let ids: string = data.map((el: any) => el.id).join();
          // customerService.batchDeletePotentialClients(ids).then(result => {
          //   if (result.status !== 200) {
          //     return;
          //   }
          //   MessageService.success("删除成功！");
          //   research();
          //   initIndicatorData();
          // })
        },
        onCancel() {
        },
      });
    };

    return {
      isHas,
      rows,
      rules,
      cols,
      data,
      paginationConfig,
      onTableChange,
      research,
      search,
      updateReqParams,
      toDoUserGroupList,
      organization,
      objectTypeList,
      enterList,
      dutyObjectTypeChange,
      superviseObjectTypeChange,
      dutyObjectList,
      superviseObjectList,
      seeDetail,
      visible,
      detailData,
      userList,
      getObjectTypeName,
      //  bottom toolbar
      bottomToolBarButtonList,
      pageInfo,
      state,
      onSelectChange,
      selectAll,
      getRequestParams,
      loadData: getData,
    };
  });

  addInfo = setup(() => {
    const store = useStore();
    const modalConfig = reactive({
      visible: false,
      modalTitle: "新增消息模板",
      type: 0, // 0：新增，1：修改
      width: 500,
    });

    const formConfig = reactive({
      name: {
        name: "名称",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 320,
      },
      code: {
        name: "编码",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 320,
      },
      remark: {
        name: "备注",
        type: "text",
        defaultValue: null,
        clearable: true,
        disable: false,
        width: 320,
      },
    });
    const form:any = reactive({
      id: null,
      name: null,
      code: null,
      remark: null,
    });
    const rules = reactive({
      name: [
        {required: true, message: "请输入模板名称", trigger: "blur"},
      ],
    });

    const showCreateModal = ()=>{
      let objStr = localStorage.getItem('todoType') || "{}";
      let obj = JSON.parse(objStr);
      for(let key in form){
        form[key] = obj[key];
      }
      modalConfig.modalTitle = '新增模板信息';
      modalConfig.type = 0;
      modalConfig.visible = true;
    }
    const edit = (data:any)=>{
      for(let key in form){
        form[key] = data[key]? data[key] + '': null
      }
      modalConfig.modalTitle = '编辑模板信息';
      modalConfig.type = 1;
      modalConfig.visible = true;
    }

    const cancel = () => {
      modalConfig.visible = false;
    };
    const getOk = () => {
      let info: any = toRaw(form);
      // modalConfig.visible = false;
      if(modalConfig.type == 0){
        todoService.createToDoType(info).then((result: any)=>{
          if(result.status != 200){
            MessageService.error('保存失败');
          }
          context.tableInfo.loadData();
          localStorage.removeItem('todoType');
          modalConfig.visible = false;
        })
      }else{
        // angelFundService.updateAngelFundOrg(info).then((result: any)=>{
        //   if(result.status != 200){
        //     message.error('保存失败');
            return
        //   }
        //   context.tableInfo.loadData();
        //   store.dispatch('getAngelFundOrg', {refresh: true})
        //   localStorage.removeItem('todoType');
        //   modalConfig.visible = false;
        // })
      }
    };

    return {
      modalConfig,
      form,
      rules,
      formConfig,
      showCreateModal,
      cancel,
      getOk,
      edit,
    };
  });

  addModalInfo = setup(() => {
    const title = ref("新增");
    const visible = ref(false);
    let editFlag = false;
    const options = [
      {label: '否', value: 0},
      {label: '是', value: 1},
    ];
    const form: any = reactive({
      id: null,
      dutyObjectType: null,
      dutyObjectId: null,
      superviseObjectType: null,
      superviseObjectId: null,
      superviseTriggerMinute: null,
      isSendSms: null,
      contentTemplate: null,
      smsTemplateCode: null,
      smsTemplateConfig: null,
      toDoTypeId: null,
      remark: null,
      parkId: null,
      dutyUserList: [],
      superviseUserList: [],
      smsContentObject: {},

    })
    let validateForm: any;
    const rules = reactive({
      dutyObjectType: [
        {required: true, type: 'number', message: '请输入名称', trigger: 'blur'}
      ], 
      // superviseObjectType: [
      //   {required: true, type: 'number', message: '请输入名称', trigger: 'blur'}
      // ], 
      isSendSms: [
        {required: true, type: 'number', message: '请输入名称', trigger: 'blur'}
      ],
    })
    const messageContentList = reactive<any>([
      {label: "test", value: "test"}
    ]);
    const selectTemplate = ref("");

    const smsMessageTypeList = reactive<any>([]);

    onMounted(() => {
      getSmsMessageTypeList();
    })

    const ok = () => {
      validateForm.validate().then(() => {
        let info = toRaw(form);
        info.parkId = parkInfo.id;
        info.toDoTypeId = toDoTypeId;
        if (info.id) {
          todoService.updateToDoTemplateConfig(info).then(result => {
            if (result.status != 200) {
              return;
            }
            visible.value = false;
            context.tableInfo.research();
            MessageService.info("编辑成功！");
          })
        } else {
          todoService.createToDoTemplateConfig(info).then(result => {
            if (result.status != 200) {
              return;
            }
            visible.value = false;
            context.tableInfo.research();
            context.tableInfo.initIndicatorData();
            MessageService.info("编辑成功！");
          })
        }
      }).catch((error: any) => {
        //console.log(error);
      });
    }
    const add = () => {
      title.value = "新增";
      clearAllForm();
      editFlag = false;
      visible.value = true;
    };
    let toDoTypeId: any = null;
    const edit = (data: any) => {
      title.value = "编辑";
      clearAllForm();
      editFlag = true;
      toDoTypeId = data.id;
      form.dutyUserList = [];
      form.superviseUserList = [];
      form.smsContentObject = {};
      if (data.toDoTemplateConfig) {
        setFormByRecord(data.toDoTemplateConfig);
        form.dutyUserList = data.toDoTemplateConfig.dutyUserIdList;
        form.superviseUserList = data.toDoTemplateConfig.superviseUserList;
        context.tableInfo.dutyObjectTypeChange();
        context.tableInfo.superviseObjectTypeChange();
        if (form.isSendSms != null) {
          form.isSendSms = parseInt(form.isSendSms);
        }

      }

      //console.log(form, "form-------------------------");


      visible.value = true;
    };
    const setValidateForm = (el: any) => {
      validateForm = el;
    }
    const clearAllForm = () => {
      for (let formKey in form) {
        Reflect.set(form, formKey, null);
      }
    }
    const setFormByRecord = (record: any) => {
      for (let formKey in form) {
        let value = Reflect.get(record, formKey);
        Reflect.set(form, formKey, value);
      }
    }

    const getSmsMessageTypeList = () => {
      messageContentList.splice(0, messageContentList.length, ...[]);
      smsMessageService.getSmsMessageTypeByScopeId(1).then((result: any) => {
        if (result.status == 200) {
          let list: any[] = result.result;
          smsMessageTypeList.splice(0, smsMessageTypeList.length, ...list);
        }
      })
    }
    const changeSmsCode = (data: any) => {
      // //console.log("code-------- ",data);、
      let messageType: any = smsMessageTypeList.find((item: any) => item.code == data);
      //console.log("messageType-----", messageType);
      let itemObject = JSON.parse(messageType.itemContent);
      // //console.log(itemObject);
      let list: any[] = [];
      for (let itemName in itemObject) {
        //console.log(itemName);
        let item = {label: itemObject[itemName], value: itemName};
        list.push(item);
      }
      messageContentList.splice(0, messageContentList.length, ...list);
      selectTemplate.value = messageType.template;
      form.content = messageType.template;
      form.signName = messageType.signName;
      // //console.log(data.template);
    }

    const changeTemplate = () => {
      let templateContent = selectTemplate.value;
      // //console.log("-------",templateContent);

      for (let keyName in form.smsContentObject) {
        let keyValue = form.smsContentObject[keyName];
        //console.log("字段名称：", keyName + ":" + keyValue);
        let searchStr = "${" + keyName + "}";

        // //console.log(templateContent.indexOf(searchStr));
        templateContent = templateContent.replaceAll(searchStr, keyValue);

      }
      // //console.log(templateContent);
      form.content = templateContent;
    }


    return {
      title,
      visible,
      edit,
      add,
      ok,
      setValidateForm,
      rules,
      form,
      options,
      smsMessageTypeList,
      messageContentList,
      changeSmsCode,
      changeTemplate
    };
  });

  delModalInfo = setup(() => {
    const doDel = (data: any) => {
      //console.log("context", context.tableInfo);
      Modal.confirm({
        title: "确定要删除么",
        icon: createVNode(QuestionCircleOutlined),
        content: "删除后将无法恢复，请慎重考虑是否删除！",
        okText: "删除",
        onOk() {
          if(!data.toDoTemplateConfig){
            todoService.deleteToDoType(data.id).then((result) => {
              if (result.status != 200) {
                return;
              }
              context.tableInfo.research();
              MessageService.info("删除成功！");
            });
          }else{
            todoService.deleteToDoTemplateConfig(data.toDoTemplateConfig.id).then((result) => {
              if (result.status != 200) {
                return;
              }
              context.tableInfo.research();
              MessageService.info("删除成功！");
            });
          }
        },
        onCancel() {
          //console.log("Cancel");
        },
        class: "test",
      });
    };

    return {doDel};
  });
}
